import { render, staticRenderFns } from "./activeColor-editor.vue?vue&type=template&id=81a50470&scoped=true&"
import script from "./activeColor-editor.vue?vue&type=script&lang=js&"
export * from "./activeColor-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81a50470",
  null
  
)

export default component.exports